import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withRouter } from 'react-router-dom';
import Input from '@material-ui/core/Input';
import Paper from '~/components/Paper';
import InputControl from '~/components/Input/InputControl';
import Form from '~/containers/Form';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import useStyles from './styles';
import ChatRecord from '~/records/ChatRecord';
import InputSelectAsync from '~/components/Input/InputSelectAsync';
import Request from '~/providers/Request';

const attrName = (attr) => ChatRecord.hummanAttributeName(attr);

function ChatItem({ record, handleChange, onSubmit, loading }) {
  const classesRoot = useStyles();

  const fetchUsers = async (input, page, resolve) => {
    Request.get('/admin/users', {
      sorter: 'name.asc',
      qs: input,
      page: page,
      perPage: 50,
    }).then((resp) => {
      const items = resp.data.map((e) => ({
        id: Number(e.id),
        name: `${e.name}${e.email ? ` <${e.email}>` : ''}`,
      }));
      resolve({ total_count: resp.meta.total, items });
    });
  };

  const fetchSpecialties = async (input, page, resolve) => {
    Request.get('/admin/specialties', {
      sorter: 'name.asc',
      qs: input,
      page: page,
      perPage: 50,
    }).then((resp) => {
      const items = resp.data.map((e) => ({
        id: Number(e.id),
        name: e.name,
      }));
      resolve({ total_count: resp.meta.total, items });
    });
  };

  return (
    <>
      <Form showFooter={true} onSubmit={onSubmit}>
        <Paper showHeader={false} loading={loading}>
          <div className={clsx(classesRoot.root)}>
            <GridContainer>
              <GridItem xs={12} md={4}>
                <InputControl
                  required
                  name={'user_to'}
                  label={attrName('user_to')}
                  value={record.get('user_to')}
                  inputComponent={InputSelectAsync}
                  onChange={handleChange}
                  InputProps={{
                    isClearable: false,
                    handleFetch: fetchUsers,
                    createEnabled: false,
                    error: false,
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={4}>
                <InputControl
                  name={'subject'}
                  autoFocus={true}
                  label={attrName('subject')}
                  value={record.get('subject')}
                  required={true}
                  inputComponent={Input}
                  onChange={handleChange}
                />
              </GridItem>
              <GridItem xs={12} md={4}>
                <InputControl
                  name={'specialty'}
                  label={attrName('specialty')}
                  value={record.get('specialty')}
                  inputComponent={InputSelectAsync}
                  onChange={handleChange}
                  InputProps={{
                    isClearable: false,
                    handleFetch: fetchSpecialties,
                    createEnabled: false,
                    error: false,
                  }}
                />
              </GridItem>
            </GridContainer>
          </div>
        </Paper>
      </Form>
    </>
  );
}

ChatItem.propTypes = {
  record: PropTypes.instanceOf(ChatRecord).isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setRecord: PropTypes.func.isRequired,
};

ChatItem.defaultProps = {
  loading: false,
};

export default React.memo(withRouter(ChatItem));
